/** サイドバーの配色（濃紺の地に載せる） */
const ICON_COLOR = "#F2F5FC";

export const IconAnalysisAssist = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M14.6673 1.00671L15.7663 3.0674L17.8269 4.16644L15.7663 5.26547L14.6673 7.32616L13.5682 5.26547L11.5075 4.16644L13.5682 3.0674L14.6673 1.00671Z"
        fill={ICON_COLOR}
      />
      <path
        d="M7.16721 3.61089L9.38942 7.77755L13.5561 9.99979L9.38942 12.222L7.16721 16.3886L4.94498 12.222L0.77832 9.99979L4.94498 7.77755L7.16721 3.61089Z"
        fill={ICON_COLOR}
      />
      <path
        d="M16.8894 13.6108L15.5006 11.0067L14.1117 13.6108L11.5075 14.9998L14.1117 16.3886L15.5006 18.9928L16.8894 16.3886L19.4936 14.9998L16.8894 13.6108Z"
        fill="#9AAEE9"
      />
    </svg>
  );
};
